module.exports = __webpack_public_path__ + "assets/img/89608195492fdd256ffd15ae5d7d83a7.svg";